module.exports = __webpack_public_path__ + "static/img/Q1000.ceceb23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Q1000.png
// module id = VWDE
// module chunks = 2